import { useContext } from 'react';

import { TimeseriesChartSelectionAreaRef } from '../context/TimeseriesChartSelectionAreaRef.context.js';

export const useTimeseriesSelectionAreaRef = () =>
  useContext(TimeseriesChartSelectionAreaRef);
